module.exports = __webpack_public_path__ + "static/media/white-box.17b4e708.svg";